// jquery
$(document).ready(() => {
  const $items = $('.r7-ksp__item');

  $items.observe((evt) => {
    const el = evt[0].target;
    if (evt[0].isIntersecting) {
      if (!el.classList.contains('r7-ksp__item--visible')) {
        TweenMax.delayedCall($items.index(el) === 2 ? 0.1 : 0, () => {
          TweenMax.to(el, 0.5, { y: 0 });
        });
        el.classList.add('r7-ksp__item--visible');
      }
    }
  });
});
